import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import { authWithReferrerUrl } from '@@/bits/location'
import { isRegistered } from '@@/bits/user_model'
import OzAvatar from '@@/library/v4/components/OzAvatar.vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from '@@/library/v4/components/OzContainedButton.vue'
import { useAppBarAccountStore } from '@@/pinia/app_bar_account'
import type { User } from '@@/types'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBarAccountAvatar',
  props: {
    user: null,
    referrerUrl: { default: undefined },
    darkMode: { type: [Boolean, String], default: 'auto' },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { user: User, referrerUrl: string, darkMode: boolean | 'auto', disabled: boolean };



const appBarAccountStore = useAppBarAccountStore()
const { showUserMenu } = appBarAccountStore

const AVATAR_SIZE = 24

const isUserRegistered = computed<boolean>(() => {
  return isRegistered(props.user)
})

const avatarUrl = computed<string | undefined>(() => {
  if (!isUserRegistered.value && !props.disabled && props.referrerUrl) {
    return authWithReferrerUrl(props.referrerUrl)
  }
  return undefined
})

const buttonLabel = computed<string>(() => {
  if (props.disabled) {
    return isUserRegistered.value
      ? __('Logged in as %{user}', { user: props.user.name || props.user.username })
      : __('Not logged in')
  }
  return isUserRegistered.value ? __('Show user menu') : __('Go to sign up page')
})

return { __sfc: true,props, appBarAccountStore, showUserMenu, AVATAR_SIZE, isUserRegistered, avatarUrl, buttonLabel, OzAvatar, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset }
}

})